import axiosInstance from "../services/axiosInstance";

export const fetchTemplatePayroll = async ({
  companyId,
  page = 1,
  perPage = 10,
  search = "",
}) => {
  try {
    const response = await axiosInstance.get("console/payroll/template/get", {
      params: {
        company_id: companyId,
        page,
        perPage,
        search,
      },
    });

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const fetchPayrollLists = async ({
  companyId,
  page = 1,
  perPage = 10,
  search = "",
}) => {
  try {
    const response = await axiosInstance.get("console/payroll/get", {
      params: {
        company_id: companyId,
        page,
        perPage,
        search,
      },
    });

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const createTemplate = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/payroll/template/create",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateTemplate = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/payroll/template/update",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteTemplate = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/payroll/template/delete",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getSingleTemplate = async (templateId) => {
  try {
    const response = await axiosInstance.get(
      "console/payroll/template/get_single",
      {
        params: { id: templateId },
      }
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// <--- BARU: Ambil Skema Gaji Personnel --->
export const getPersonnelSchema = async (personnelId, companyId) => {
  try {
    const response = await axiosInstance.get(
      "console/payroll/personnel/get_schema",
      {
        params: { personnel_id: personnelId, company_id: companyId },
      }
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// <--- BARU: Update Skema Gaji Personnel --->
export const updatePersonnelSchema = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/payroll/personnel/update_schema",
      payload
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Fungsi untuk fetch payroll templates untuk select component
export const fetchSelectPayrollTemplates = async (
  company_id,
  keyword = "",
  defaultValue = ""
) => {
  try {
    const params = {
      company_id: company_id,
    };

    if (keyword) {
      params.keyword = keyword;
    }

    if (defaultValue) {
      params.id = defaultValue;
    }

    const response = await axiosInstance.get(
      "/console/payroll/template/select",
      {
        params: params,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching payroll templates:", error);
    throw error;
  }
};

export const savePayroll = async (payload) => {
  try {
    const response = await axiosInstance.post("console/payroll/save", payload);

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const calculatePayroll = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/payroll/calculate",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getPayrollDetail = async (payrollId) => {
  try {
    const response = await axiosInstance.get(
      `/console/payroll/detail/${payrollId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching payroll detail:", error);
    throw error;
  }
};

export const publishPayrollSingle = async (payrollDetailId) => {
  try {
    const response = await axiosInstance.post(
      `console/payroll/publish/single/${payrollDetailId}`
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const downloadPayrollSingle = async (payrollId) => {
  try {
    const response = await axiosInstance.get(
      `console/payroll/download/single/${payrollId}`,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.error("Error downloading bulk payroll:", error);
    throw error;
  }
};
